import { useEffect } from 'react';
import { images } from '../../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../../HelperComponents/AnywhereHorizontalScroll';
import { selectProductHandler } from '../../../StoreHomePage/BogoClothDiaper/common';
import { MorePrintContainer, MorePrintTitle } from './styled';
import VariantCard from './VariantCard';

export default function MoreVariantsCard(props) {
  const {
    otherProductImages,
    setOfferCartData,
    productId,
    setVariantProductId,
    variantProductId,
    hideStickyStrip,
    setPopupImages,
  } = props;

  const variantClickHandler = async (productId) => {
    const diaperOfferData = await selectProductHandler(
      productId,
      otherProductImages,
    );
    if (!hideStickyStrip) setOfferCartData(diaperOfferData?.data);
    else setPopupImages(diaperOfferData?.data);
    setVariantProductId(productId);
  };
  useEffect(() => {
    document.getElementById(`card_${productId}`)?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
    });
  }, []);

  return (
    <MorePrintContainer>
      <MorePrintTitle>Explore More Prints</MorePrintTitle>
      <AnywhereHorizontalScroll
        bogo={true}
        firstElementId={`card_${otherProductImages?.[0]?.id}`}
        lastElementId={`card_${
          otherProductImages[otherProductImages.length - 1]?.id
        }`}
        leftArrow={<img src={images.arrowdownforward} alt="" />}
        rightArrow={<img src={images.arrowdownforward} alt="" />}
        scrolledWidth={440}
      >
        {otherProductImages?.map((element, index) => {
          return (
            <VariantCard
              data={element}
              index={index}
              id={`card_${element?.id}`}
              key={`carousel_${index}`}
              variantClickHandler={variantClickHandler}
              productId={variantProductId}
            />
          );
        })}
      </AnywhereHorizontalScroll>
    </MorePrintContainer>
  );
}
